module.exports = __webpack_public_path__ + "img/Cornelis vd Lijnstraat voor.0dfe1a48.jpg";